<script>
  import CreateTask from "./createTask.svelte";
  import { user } from "../firebase";
  import { meta } from "tinro";
  import { baseAPIUrl } from "../globals";
  import { conversion, lang } from "../store/store";

  import { authenticatedFetch } from "../appbridge";

  import { getAuth, signOut } from "firebase/auth";
  export let createTask;

  let data = {
    title: "",
    description: "",
    priority: { name: "Normale", id: 3, value: "Low" },
    attachments: {},
  };
  /*
import {getSessionToken, authenticatedFetch} from '../appbridge'
*/
  let route = meta();
  $: {
    console.log($route.url);
  }
  let redirects = {
    a: $conversion[$lang].navbar[1],
    b: $conversion[$lang].navbar[2],
    c: $conversion[$lang].navbar[3],
    d: $conversion[$lang].navbar[4],
  };

  let items = [
    {
      name: $conversion[$lang].navbar[6],
      photo: "../images/menu/user.svg",
      ref: "/account",
    },
    {
      name: $conversion[$lang].navbar[7],
      photo: "../images/menu/transaction.svg",
      ref: "/transaction-history",
    },
    // {
    // 	name: "Testimonials",
    // 	photo: "../images/menu/testimonials.svg",
    // 	ref: "",
    // },
    // {
    // 	name: "Support",
    // 	photo: "../images/menu/support.svg",
    // 	ref: "",
    // },
    // {
    // 	name: "FAQ",
    // 	photo: "../images/menu/faq.svg",
    // 	ref: "",
    // },
  ];

  let menu = false;
  let current = redirects.a;
  let unread;
  let temp;
  $user.doc.subscribe((v) => {
    console.log(v);
    temp =
      v?.account?.img ||
      "https://firebasestorage.googleapis.com/v0/b/expertify-tasks-dev.appspot.com/o/assets%2Fuser.png?alt=media&token=c7eff643-3c19-47a0-8ddf-0150f58de8f8";
    unread = v?.unread;
  });

  console.log(unread);

  $: {
    if (!!document.getElementById("m")) {
      if (menu) {
        document.getElementById("m").style.display = "flex";
      } else {
        document.getElementById("m").style.display = "none";
      }
    }
  }

  const sendToken = async () => {
    const resp = await authenticatedFetch(baseAPIUrl + "/test", {
      method: "GET",
      mode: "cors",
    });

    console.log(await resp.text());
  };

  const doLogOut = () => {
    const auth = getAuth();
    signOut(auth)
      .then(() => {
        // Sign-out successful.
        window.location.reload();
      })
      .catch((error) => {
        // An error happened.
      });
  };

  let mobile = false;
</script>

{#if createTask}
  <CreateTask bind:createTask bind:data />
{/if}
<div class="topbar-ctn">
  <div class="leftside">
    <a href="/">
      <img
        style="width: 170px;"
        src="../images/expertifyTasks.png"
        alt="Expertify logo"
      />
    </a>
  </div>
  <div class="middle">
    <a
      href="/"
      class:active={$route.url == "/"}
      class="redirect-txt slide-center-out"
    >
      <div class="slide-center-out">{redirects.a}</div>
    </a>
    <a
      href="/tasks"
      class:active={$route.url == "/tasks"}
      class="redirect-txt slide-center-out"
    >
      <div class="slide-center-out">{redirects.b}</div>
    </a>
    <a
      href="/transaction-history"
      class:active={$route.url == "/transaction-history"}
      class="redirect-txt slide-center-out"
    >
      <div class="slide-center-out">{redirects.c}</div>
    </a>
    <a
      href="/notifications"
      class:active={$route.url == "/notifications"}
      class="redirect-txt slide-center-out"
    >
      {#if unread}
        {#if unread > 9}
          <div style="padding: 0.15rem 0.25rem;" class="notif-count">+9</div>
        {:else}
          <div class="notif-count">{unread}</div>
        {/if}
      {/if}
      <div class="slide-center-out">{redirects.d}</div>
    </a>
  </div>
  <div class="rightside">
    <div
      class="task btn"
      on:click={() => {
        createTask = true;
      }}
    >
      <div class="task-plus">
        <svg
          version="1.1"
          id="Layer_1"
          xmlns="http://www.w3.org/2000/svg"
          xmlns:xlink="http://www.w3.org/1999/xlink"
          x="0px"
          y="0px"
          viewBox="-162 239 24 24"
          style="enable-background:new -162 239 24 24;"
          xml:space="preserve"
        >
          <g>
            <path
              style="fill:white"
              d="M-141,253.4h-18c-1.7,0-3-1.3-3-3l0,0c0-1.7,1.3-3,3-3h18c1.7,0,3,1.3,3,3l0,0C-138,252.1-139.3,253.4-141,253.4z"
            />
            <path
              style="fill:white"
              d="M-153,260v-18c0-1.7,1.3-3,3-3l0,0c1.7,0,3,1.3,3,3v18c0,1.7-1.3,3-3,3l0,0C-151.7,263-153,261.7-153,260z"
            />
          </g>
        </svg>
      </div>
      <div class="task-txt">{$conversion[$lang].navbar[5]}</div>
    </div>
    <div
      on:click={() => {
        menu = !menu;
      }}
      class="user-ctn"
    >
      <div class="down-arr">
        <svg
          version="1.1"
          id="Layer_1"
          xmlns="http://www.w3.org/2000/svg"
          xmlns:xlink="http://www.w3.org/1999/xlink"
          x="0px"
          y="0px"
          viewBox="-162 239 24 24"
          style="enable-background:new -162 239 24 24;"
          xml:space="preserve"
        >
          <polygon
            style="fill:var(--primaryColor);"
            points="-138,245.8 -150,257.8 -162,245.8 "
          />
        </svg>
      </div>
      <div id="m" class="dropmenu">
        {#each items as item}
          <a href={item.ref} class="dropmenu-wrapper">
            <div class="dropmenu-img">
              <img src={item.photo} alt={item.name} />
            </div>
            <div class="dropmenu-txt">{item.name}</div>
          </a>
        {/each}
        <a href="#" on:click={doLogOut} class="dropmenu-wrapper">
          <div class="dropmenu-img">
            <img src="../images/menu/logout.svg" alt="Logout" />
          </div>
          <div class="dropmenu-txt">{$conversion[$lang].navbar[8]}</div>
        </a>
      </div>
      <div class="user-img"><img src={temp} alt="User" /></div>
    </div>
  </div>
  <div
    class="mobileBtn"
    on:click={() => {
      mobile = !mobile;
      console.log(mobile);
    }}
  >
    <img src="../images/menu.svg" alt="menu" />
  </div>
</div>
<div class="mobileMenu" class:mobile>
  <div class="mobilemenuMain">
    <div
      class="closeMenuButton"
      on:click={() => {
        mobile = false;
      }}
    >
      <i class="bx bx-x" />
    </div>
    <div class="rightside">
      <a href="#b" on:click={sendToken} class="pro btn">Become Pro</a>
      <div
        class="task btn"
        on:click={() => {
          createTask = true;
        }}
      >
        <div class="task-plus">
          <svg
            version="1.1"
            id="Layer_1"
            xmlns="http://www.w3.org/2000/svg"
            xmlns:xlink="http://www.w3.org/1999/xlink"
            x="0px"
            y="0px"
            viewBox="-162 239 24 24"
            style="enable-background:new -162 239 24 24;"
            xml:space="preserve"
          >
            <g>
              <path
                style="fill:white"
                d="M-141,253.4h-18c-1.7,0-3-1.3-3-3l0,0c0-1.7,1.3-3,3-3h18c1.7,0,3,1.3,3,3l0,0C-138,252.1-139.3,253.4-141,253.4z"
              />
              <path
                style="fill:white"
                d="M-153,260v-18c0-1.7,1.3-3,3-3l0,0c1.7,0,3,1.3,3,3v18c0,1.7-1.3,3-3,3l0,0C-151.7,263-153,261.7-153,260z"
              />
            </g>
          </svg>
        </div>
        <div class="task-txt">{$conversion[$lang].navbar[5]}</div>
      </div>
      <div class="user-ctn">
        <!-- Arrow -->
        {#if menu == false}
          <div
            class="down-arr"
            on:click={() => {
              menu = !menu;
              console.log(menu);
            }}
          >
            <i class="bx bxs-down-arrow" />
          </div>
        {/if}
        {#if menu == true}
          <div
            class="down-arr"
            on:click={() => {
              menu = !menu;
              console.log(menu);
            }}
          >
            <i class="bx bxs-up-arrow down-arr" />
          </div>
        {/if}

        <div id="m" class="dropmenu">
          {#each items as item}
            <a href={item.ref} class="dropmenu-wrapper">
              <div class="dropmenu-img">
                <img src={item.photo} alt={item.name} />
              </div>
              <div class="dropmenu-txt">{item.name}</div>
            </a>
          {/each}
          <a href="#" on:click={doLogOut} class="dropmenu-wrapper">
            <div class="dropmenu-img">
              <img src="../images/menu/logout.svg" alt="Logout" />
            </div>
            <div class="dropmenu-txt">Logout</div>
          </a>
        </div>
        <div class="user-img"><img src={temp} alt="User" /></div>
      </div>
    </div>

    <!-- Middle in the mobile version -->
    <div class={menu == true ? "middle MOBILEMENUHIDDEN" : "middle MOBILEMENU"}>
      <a
        href="/"
        class:active={$route.url == "/"}
        class="redirect-txt slide-center-out"
      >
        <div class="slide-center-out">{redirects.a}</div>
      </a>
      <a
        href="/tasks"
        class:active={$route.url == "/tasks"}
        class="redirect-txt slide-center-out"
      >
        <div class="slide-center-out">{redirects.b}</div>
      </a>
      <a
        href="/transaction-history"
        class:active={$route.url == "/transaction-history"}
        class="redirect-txt slide-center-out"
      >
        <div class="slide-center-out">{redirects.c}</div>
      </a>
      <a
        href="/notifications"
        class:active={$route.url == "/notifications"}
        class="redirect-txt slide-center-out"
      >
        {#if unread}
          {#if unread > 9}
            <div style="padding: 0.15rem 0.25rem;" class="notif-count">+9</div>
          {:else}
            <div class="notif-count">{unread}</div>
          {/if}
        {/if}
        <div class="slide-center-out">{redirects.d}</div>
      </a>
      <a
        href="/account"
        class:active={$route.url == "/account"}
        class="redirect-txt slide-center-out"
      >
        {#if unread}
          {#if unread > 9}
            <div style="padding: 0.15rem 0.25rem;" class="notif-count">+9</div>
          {:else}
            <div class="notif-count">{unread}</div>
          {/if}
        {/if}
        <div class="slide-center-out">{$conversion[$lang].navbar[6]}</div>
      </a>
      <a href="#" on:click={doLogOut} class="redirect-txt slide-center-out">
        {#if unread}
          {#if unread > 9}
            <div style="padding: 0.15rem 0.25rem;" class="notif-count">+9</div>
          {:else}
            <div class="notif-count">{unread}</div>
          {/if}
        {/if}
        <div class="slide-center-out">{$conversion[$lang].navbar[8]}</div>
      </a>
    </div>
  </div>
</div>

<style>
  .topbar-ctn {
    background-color: white;
    padding: 0.6rem 2.5rem 0.6rem 2rem;
    display: flex;
    border-bottom: solid 1px #edf2f7;
    justify-content: space-around;
  }

  /****************************leftside start**************************/

  .leftside {
    display: flex;
    flex-direction: column;
    align-content: space-between;
    align-items: center;
    justify-content: center;
  }

  .redirect-txt {
    color: #718096;
    transition: color 0.8s ease;
    cursor: pointer;
    font-size: 0.85em;
    font-weight: 600;
    position: relative;
  }

  .redirect-txt:hover {
    color: var(--primaryColor);
    transition: color 0.8s ease;
  }

  .slide-center-out {
    text-decoration: none;
    display: inline-block;
  }

  .slide-center-out:after {
    content: "";
    display: block;
    height: 1px;
    width: 0;
    background: var(--primaryColor);
    transition: width 0.4s cubic-bezier(0.45, 0, 0.55, 1);
    margin: auto;
  }
  .active .slide-center-out:after {
    width: 100%;
  }
  .active {
    color: var(--primaryColor);
  }

  /****************************leftside end**************************/

  /****************************rightside start**************************/

  .rightside {
    display: flex;
    align-items: center;
    justify-content: flex-end;
    font-size: 0.7em;
  }

  .pro {
    color: var(--primaryColor);
    border: 1px solid var(--primaryColor);
    border-radius: 8px;
    background-color: transparent;
    font-weight: 500;
  }

  .task {
    color: white;
    border-radius: 8px;
    background-color: var(--primaryColor);
    display: flex;
    font-weight: 500;
  }

  .btn {
    padding: 0.5rem 1.1rem;
    max-width: 20rem;
    margin: 0 0.5rem;
    cursor: pointer;
  }
  .task-plus {
    width: 0.5rem;
    margin-right: 0.5rem;
  }

  .user-ctn {
    position: relative;
    display: flex;
    justify-content: center;
    align-items: center;
    cursor: pointer;
    margin-left: 0.5rem;
  }

  .down-arr {
    width: 0.8rem;
    margin-right: 0.5rem;
  }

  .user-img {
    border-radius: 50%;
    display: flex;
    width: 3rem;
    height: 3rem;
    overflow: hidden;
  }

  /****************************rightside end**************************/
  .middle {
    display: flex;
    width: 55%;
    align-items: center;
    justify-content: space-evenly;

    /* max-height: 0rem; */
  }

  .dropmenu {
    position: absolute;
    top: 120%;
    right: -57%;
    width: 240%;
    background-color: white;
    display: none;
    flex-direction: column;
    border-radius: 16px;
    box-shadow: 0px 1px 2px rgba(184, 200, 224, 0.222055);
    border: 1px solid #d8e0f0;
    /* padding: 0.8rem 0 0.8rem 0.8rem; */
    padding: 0.8rem;
    color: black;
    z-index: 100;
  }

  .dropmenu-wrapper {
    display: flex;
    flex-direction: row;
    margin: 0.275rem 0;
    /*align-items:center;*/
  }

  .dropmenu-txt {
    font-size: 1.2em;
    color: black;
    font-weight: 600;
  }

  .dropmenu-img {
    width: 20px;
    margin-right: 0.6rem;
  }

  .notif-count {
    position: absolute;
    background: #2c8f73;
    border-radius: 50%;
    padding: 0.2rem;
    top: -14px;
    right: -13px;
    color: white;
    padding: 0.1rem 0.35rem;
    font-size: 0.7em;
  }
  .mobileMenu,
  .mobileBtn {
    display: none;
  }
  .mobileMenu,
  .mobileMenu.mobile {
    display: none;
  }
  @media only screen and (max-width: 1100px) {
    .middle,
    .rightside {
      display: none;
    }
    .mobileBtn {
      display: flex;
      align-items: center;
      cursor: pointer;
    }
    .mobileBtn img {
      width: 30px;
    }
    .topbar-ctn {
      justify-content: space-between;
      align-items: center;
    }
    .MOBILEMENUHIDDEN {
      opacity: 0;
      transition: 1s ease-in-out;
    }

    .MOBILEMENU {
      opacity: 1;
      transition: 1s ease-in-out;
    }
  }

  .mobileMenu.mobile {
    display: block;
    height: 100%;
    width: 300px;
    position: absolute;
    right: 0;
    top: 0;
    background: white;
    z-index: 999;
    /* padding-top: 10%; */
  }
  .mobileMenu .middle,
  .mobileMenu .rightside {
    display: flex;
    flex-direction: column;
    width: 90%;
  }
  .mobileMenu .rightside a,
  .mobileMenu .rightside .task.btn,
  .mobileMenu .rightside .user-ctn {
    margin: 10px 0;
    width: 100%;
  }

  .mobilemenuMain {
    padding-top: 20%;
    display: flex;
    flex-direction: column;
    height: 100%;
    width: 100%;
    position: relative;
    align-items: center;
  }

  .closeMenuButton {
    position: absolute;
    top: 0px;
    right: 15px;
    font-weight: 500;
    font-size: 2em;
  }

  .closeMenuButton:hover {
    color: #2c8f73;

    font-size: 2.5em;
    border-radius: 30%;
    /* padding: 0.5rem; */
    transition: 0.5s;
  }

  .display {
    display: flex;
  }

  .none {
    display: none;
  }
</style>